<main id="db-wrapper" class="bg-light">

  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>

  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">Admin Portal</h1>
              </div>
            </div>
          </div>
        </div>
        <div class="row gx-3">
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center h-100 justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div class="d-flex justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"

                    ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <app-form-spinner></app-form-spinner>
      </div>
    </div>
    <div class="container-fluid p-4" *ngIf="!loading">
      <div class="row">
        <div class="col-lg-12">
          <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
            <div class="mb-3 mb-lg-0">
              <h1 class="mb-0 h2 fw-bold">Notifictions & Alerts</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xxl-12 col-md-12">
          <p-scrollpanel [style]="{ width: '100%', height: '750px' }">
            <ul class="list-group list-group-flush  card  p-5"  data-simplebar>
              <li class="list-group-item " *ngFor="let item of notifications">
                <div class="row">
                  <div class="col">
                    <a class="text-body">
                      <div class="d-flex">
                        <img src="../../../assets/SideBar/bell-alarm.png" alt=""
                          class="avatar-lg rounded-circle" >
                        <div class="ms-3">
                          <h5 class="fw-bold mb-1">{{item.workflowStep }} {{ item.title}}</h5>
                          <p class="mb-3 text-body truncate-text">
                          {{item.message}}
                          </p>
                          <span class="fs-6 text-muted">
                            <span class="ms-1 badge "  [ngClass]="{'bg-red': item.timestamp === latestTimestamp, 'bg-success': item.timestamp !== latestTimestamp}">{{item.timestamp | date:'MM-dd-yyyy HH:mm:ss:a'}}</span>
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
  
                </div>
              </li>
  
            </ul>
          </p-scrollpanel>
         


        </div>
      </div>
      </div>
  </section>
</main>
